var _a, _b, _c;
import { __decorate, __metadata, __param } from "tslib";
import { inject, injectable } from 'inversify';
import { PageSelectorServiceSymbol } from '@/presentation/components/page-selector/PageSelectorService.interface';
import { DataType } from '@/domains/base/enums/data-type';
import { I18nService } from '@/services/i18n-service';
import { FolderService } from '@/domains/detail/folder/types/folder-service.interface';
import { UserService } from '@/domains/user/services/user-service.interface';
import { EXPORT_PAPER_LIMIT } from './constants';
let ExportPaperActionContribution = class ExportPaperActionContribution {
    // eslint-disable-next-line max-params
    constructor(_pageSelectorService, _i18nService, _folderService, _userService) {
        this._pageSelectorService = _pageSelectorService;
        this._i18nService = _i18nService;
        this._folderService = _folderService;
        this._userService = _userService;
    }
    registerDataTypeActions(registry) {
        registry.registerAction({
            commandId: 'export-papers',
            iconClass: 'SolidExport',
            label: this._i18nService.t('folder.selector.export'),
            whenDataType: DataType.PAPER,
            isEnabled: () => {
                return this._pageSelectorService.selectedCount > 0
                    && this._pageSelectorService.selectedCount <= EXPORT_PAPER_LIMIT
                    && this._userService.userPermission.npl;
            },
            isVisible: () => {
                return !this._userService.userPermission.npl || this._folderService.folderPermission.enable_export_paper;
            },
            tooltip: () => {
                if (this._pageSelectorService.selectedCount > EXPORT_PAPER_LIMIT) {
                    return this._i18nService.t('ExportPaper.errors.reachLimit', { count: EXPORT_PAPER_LIMIT });
                }
                if (!this._userService.userPermission.npl) {
                    return this._i18nService.t('ExportPaper.errors.accessDenied');
                }
            },
        });
    }
};
ExportPaperActionContribution = __decorate([
    injectable(),
    __param(0, inject(PageSelectorServiceSymbol)),
    __param(1, inject(I18nService)),
    __param(2, inject(FolderService)),
    __param(3, inject(UserService)),
    __metadata("design:paramtypes", [Object, typeof (_a = typeof I18nService !== "undefined" && I18nService) === "function" ? _a : Object, typeof (_b = typeof FolderService !== "undefined" && FolderService) === "function" ? _b : Object, typeof (_c = typeof UserService !== "undefined" && UserService) === "function" ? _c : Object])
], ExportPaperActionContribution);
export { ExportPaperActionContribution };
